module.exports = __webpack_public_path__ + "static/media/person_purple.3424c7da.png";